import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: 20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function WhatYouGetSection() {
  const deliverables = [{
    title: 'El Manual Maestro (PDF)',
    desc: 'La guía paso a paso donde te explico cómo identifiqué mis propios puntos ciegos para pasar de deudas masivas a generar millones operando desde el ser.'
  }, {
    title: 'El Protocolo RMA de 48 Horas',
    desc: 'Un ejercicio práctico diseñado para ejecutarse en dos días. Es intenso, es confrontacional y es lo más real que harás en tu vida.'
  }, {
    title: 'La Matriz del Termostato',
    desc: 'Una herramienta para calcular tu límite subconsciente actual y las instrucciones exactas para expandirlo un 300% de manera segura para tu sistema nervioso.'
  }, {
    title: 'Auditoría de Frecuencia Diaria',
    desc: "Una hoja de ruta para que identifiques si estás operando en modo 'Supervivencia' o en modo 'Creación' en tiempo real."
  }, {
    title: 'BONUS: El Manifiesto del Rico Educado',
    desc: 'Por qué las masas se entretienen mientras la élite se educa, y cómo hackear tu consumo de información para acelerar tu riqueza.',
    isBonus: true
  }];
  return <section className="py-16 md:py-[80px] px-4" data-id="element-355">
      <div className="max-w-[1000px] mx-auto" data-id="element-356">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-357">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-358">
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-359"></span>
            El Mapa de Salida
          </div>
          <h2 className="mb-4 font-heading text-3xl md:text-[40px] font-black leading-[1.1] text-white uppercase tracking-tight" data-id="element-360">
            LO QUE RECIBES <span className="text-gold" data-id="element-361">HOY</span>
          </h2>
          <p className="text-[15px] text-text-secondary max-w-[600px]" data-id="element-362">
            Al adquirir El Código de Identidad 1.0, no solo recibes un PDF.
            Recibes el mapa de salida de la habitación de cristal.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start" data-id="element-363">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative rounded-lg border-2 border-border overflow-hidden bg-surface-dark" data-id="element-364">
            <div className="absolute inset-0 bg-gradient-to-tr from-gold/10 to-transparent opacity-50" data-id="element-365" />
            <img src="https://cdn.magicpatterns.com/uploads/iBw6vUSaqNBggWK3KQ7K5H/Imagen_Codigo_de_identidad-3.png" alt="El Código de Identidad 1.0 Mockup" className="relative z-10 w-full h-auto object-cover p-8" data-id="element-366" />
          </motion.div>

          <motion.div className="overflow-hidden rounded-lg border border-border bg-surface" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} data-id="element-367">
            <div className="flex items-center gap-2 border-b border-border bg-surface-light px-[18px] py-3" data-id="element-368">
              <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-369"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-gold uppercase" data-id="element-370">
                Contenido del Sistema
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-text-card" data-id="element-371">
              <ul className="flex flex-col" data-id="element-372">
                {deliverables.map((item, index) => <motion.li key={index} variants={itemVariants} className={`flex flex-col gap-1 border-b border-border py-3 last:border-0 last:pb-0 ${item.isBonus ? 'bg-gold/5 -mx-[18px] px-[18px] border-y border-gold/20' : ''}`} data-id="element-373">
                    <div className="flex items-start gap-2" data-id="element-374">
                      <span className="mt-[2px] shrink-0 font-bold text-gold" data-id="element-375">
                        →
                      </span>
                      <strong className={item.isBonus ? 'text-gold' : 'text-white'} data-id="element-376">
                        {item.title}
                      </strong>
                    </div>
                    <div className="pl-6 text-[#888]" data-id="element-377">{item.desc}</div>
                  </motion.li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}